
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvTaskValidationForm.html?raw';
import { ApplicatonMode, EvTaskTypes, InfoPanel } from "../../_loadingHelpers/EvTask";
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import { ToasterHelpers } from "../../../more/Helpers";


class ValidationForm extends compose(_StatefulSection) {
    templateString: any = template;

    private inputEvTaskStart: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputEvTaskEnd: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputEvTaskEndActual: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputEvTaskStartActual: MdsLax<InstanceType<typeof DateTimeInput>>;

    private cbIsConfirmed: MdsLax<InstanceType<typeof CheckBox>>;

    private btnSave: HTMLButtonElement;

    private entityID: string = null;
    private entityData: EvTaskTypes.InfoPanelData;
    private infoPanelLoaded: boolean = false;

    infoPanel: MdsLax<InstanceType<typeof InfoPanel>>;

    setup(evTaskID: string) {
        this.entityID = evTaskID;

        this.loadData();
    }

    loadData() {
        if (this.entityID) {
            this.setStartupState("loading");
            this.infoPanel.loadById(this.entityID);
        } else {
            this.setStartupState("ready");
        }
    }

    private _onLoadedInfoPanel(data: EvTaskTypes.InfoPanelData) {
        this.infoPanelLoaded = true;
        
        this.setData(data);
    }

    onDirtyChange(state) {
        this.UiModder.domClass.toggle(this.btnSave, "w3-disabled", this.isDirty() != true);
    }

    afterSetData() {
        let data = this.sourceData as EvTaskTypes.InfoPanelData;

        this.UiModder.domClass.toggle(this.domNode, "w3-disabled", data.EmployeeID != window.sessionInfo?.sessionData?.CurrentEmployeeId);

        //this.inputEvTaskStart.setValue(data.date_start);
        //this.inputEvTaskEnd.setValue(data.date_end);

        let dateStartActual = data.date_start_actual ? data.date_start_actual : data.date_forerun;
        let dateEndActual = data.date_end_actual ? data.date_end_actual : data.date_trailer;

        this.UiModder.domClass.toggle(this.btnSave, "w3-disabled", data.is_actual_times_confirmed_by_employee == true);

        //this.inputEvTaskStartActual.setValue(dateStartActual);
        //this.inputEvTaskEndActual.setValue(dateEndActual);

    }

    private _onClick_Save(evt: MouseEvent) {
        let data = this.sourceData as EvTaskTypes.InfoPanelData;

        this.saveActualTimes();
    }

    private saveActualTimes() {

        this.StandbyStart();
        this.emit("saving");

        this.UiModder.domClass.add(this.btnSave, "w3-disabled");

        let data = {
            evTaskID: this.entityID,
            dateStartActual: this.dateToLocalISOString(this.inputEvTaskStartActual.getValue().date), // stringify macht sonst merkwürdigen Offset mit Sekunden und ms
            dateEndActual: this.dateToLocalISOString(this.inputEvTaskEndActual.getValue().date)
        };


        this.RequestManager.post(
            window.appRoot + "EvTask/SaveActualTimes",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError)
        );
    }

    private _onSaveDataResponse(response) {
        this.StandbyStop();

        this.emit("saved", true);

        this.resetDirty();

        this.showToast({
            title: this.translations["General__SaveSuccess"],
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

        this.setup(this.entityID);
    }

    private _onSaveDataError(error: more.requestErrorMessage) {
        this.StandbyStop();

        this.UiModder.domClass.remove(this.btnSave, "w3-disabled");

        this.showToast({
            title: this.translations["General__ProcessFailed"],
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message
        });

        this.emit("saved", false);
    }

    private _onChange_ActualTimes() {
        this.cbIsConfirmed.setValue(false);
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ValidationForm);